import t from 'tcomb';
import URL from './URL';
import Color from './Color';

const Background_Position = t.enums.of([
  'left top',
  'left center',
  'left bottom',
  'right top',
  'right center',
  'right bottom',
  'center top',
  'center center',
  'center bottom'
], 'Background_Position');

const Repeat = t.enums.of([
  'repeat',
  'repeat-x',
  'repeat-y',
  'no-repeat'
], 'Repeat');

const Attachment = t.enums.of([
  'scroll',
  'fixed'
], 'Attachment');

const Sponsor_Background = t.struct({
  color: t.maybe(Color),
  image: t.maybe(URL),
  position: t.maybe(Background_Position),
  repeat: t.maybe(Repeat),
  attachment: t.maybe(Attachment)
}, 'Sponsor_Background');

const Sponsor = t.struct({
  name: t.String,
  logo: t.maybe(URL),
  tutorial: t.maybe(URL),
  description: t.maybe(t.String),
  tagline: t.maybe(t.String),
  privacy: t.maybe(t.String),
  color: Color,
  bg_color: Color,
  image: t.maybe(URL),
  background: t.maybe(Sponsor_Background),
  welcome_name: t.maybe(t.String),
  welcome_logo: t.maybe(URL),
  welcome_image: t.maybe(URL),
  welcome_tutorial: t.maybe(URL),
  welcome_description: t.maybe(t.String),
  welcome_color: t.maybe(Color),
  welcome_bg_color: t.maybe(Color)
}, 'Sponsor');

export default Sponsor;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Sponsor.js
 **/